"use strict";

import $ from "jquery";

function init() {
    $(".angular-app").each(function () {
        const el = $(this);

        import("angular").then(function (angular) {
            console.log(
                "%cINIT",
                "padding:0 4px;background:#090;color:#fff",
                "angular:",
                angular.version.full,
            ); // eslint-disable-line no-console

            import("../cartApp").then(function () {
                angular.element(el).ready(() => {
                    angular.bootstrap(el, ["cartApp"]);
                });
            });
        });
    });

    $(".angular-vacancies").each(function () {
        const el = $(this);

        import("angular").then(function (angular) {
            import("../vacancyApp").then(function () {
                angular.element(el).ready(() => {
                    angular.bootstrap(el, ["vacancyApp"]);
                });
            });
        });
    });
    $(".angular-customer-references").each(function () {
        const el = $(this);

        import("angular").then(function (angular) {
            import("../custRefApp").then(function () {
                angular.element(el).ready(() => {
                    angular.bootstrap(el, ["custRefApp"]);
                });
            });
        });
    });
    $(".angular-news").each(function () {
        const el = $(this);

        import("angular").then(function (angular) {
            import("../newsApp").then(function () {
                angular.element(el).ready(() => {
                    angular.bootstrap(el, ["newsApp"]);
                });
            });
        });
    });
    $(".angular-calculator").each(function () {
        const el = $(this);

        import("angular").then(function (angular) {
            import("../calculatorApp").then(function () {
                angular.element(el).ready(() => {
                    angular.bootstrap(el, ["calculatorApp"]);
                });
            });
        });
    });
}

export default {
    init,
};
